<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            <span v-if="room.id">Редактирование зала</span>
                            <span v-else>Добавление зала</span>
                        </span>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Наименование</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.room.name.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"></i></label>
                                    </label>
                                    <div v-if="$v.room.name.$error === true || forms.room.errors.name" class="error">
                                        {{ this.forms.room.errors.name ? this.forms.room.errors.name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Филиал</label>
                                    <label class="field select">
                                        <select v-model="room.filiationId">
                                            <option disabled="">Выберите филиал</option>
                                            <option
                                                    v-for="filiation in data.filiations"
                                                    v-bind:key="filiation.id"
                                                    :value="filiation.id"
                                            >
                                                {{filiation.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.room.filiationId.$error === true || forms.room.errors.filiation_id" class="error">
                                        {{ this.forms.room.errors.filiation_id ? this.forms.room.errors.filiation_id.join(', ') : 'Выберите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Вместимость</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.room.capacity.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-home"></i></label>
                                    </label>
                                    <div v-if="$v.room.capacity.$error === true || forms.room.errors.capacity" class="error">
                                        {{ this.forms.room.errors.capacity ? this.forms.room.errors.capacity.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Описание</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.room.content.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.room.isSubmitting">
                                <span v-if="room.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import FitnessRoom from "../../models/FitnessRoom";
    import Filiation from "../../models/Filliation";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {

            if (to.params.id) {
                try {
                    const fitnessRoom = await FitnessRoom.get(to.params.id);
                    const Filiations = await Filiation.getList(1, 999);
                    next(async component => {
                        component.room = fitnessRoom;
                        component.data.filiations = Filiations.data;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                const Filiations = await Filiation.getList(1, 999);
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                    component.data.filiations = Filiations.data;
                });
            }
        },
        data() {
            return {
                data: {
                    filiations: [],
                },
                room: new FitnessRoom(),
                forms: {
                    room: {
                        isSubmitting: false,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            room: {
                name: {required},
                content: {},
                capacity: {},
                filiationId: {},
            },
        },
        methods: {
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.room.isSubmitting = true;
                this.forms.room.errors = {};

                if (this.room.id) {

                    try {
                        await this.room.update();
                    } catch (error) {
                        this.forms.room.errors = error.errors;
                    }

                } else {

                    try {
                        await this.room.add();

                        await this.$router.push({name: 'room-edit', params: {id: this.room.id}});
                    } catch (error) {
                        this.forms.room.errors = error.errors;
                    }

                }

                this.forms.room.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Залы - ' + (this.room.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>